<div class="documentos-prestador-container">
    <form [formGroup]="form">
        <app-card-content [border]="false" [headerColor]="true" icon="pi pi-file-text" title="Documentos" subtitle="Documentos e registros do prestador">
            <div card-header>
                <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [destaque]="itensEdicao" [destaqueAtivo]="isEditing" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" />
            </div>

            <div class="flex flex-col gap-4">
                <app-card-content [headerColor]="true" icon="pi pi-id-card" title="Identificação">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-[240px]">
                            <label class="font-semibold block mb-2">CNPJ - Número</label>
                            <p-inputmask formControlName="cnpj" mask="99.999.999/9999-99" placeholder="00.000.000/0000-00" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[260px]">
                            <label class="font-semibold block mb-2">Instituído por</label>
                            <p-select appendTo="body" formControlName="inInstituido" [options]="opcoesInstituido" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[260px]">
                            <label class="font-semibold block mb-2">Natureza Jurídica</label>
                            <p-select appendTo="body" formControlName="idNaturezaEmpresa" [options]="opcoesNaturezaEmpresa" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-verified" title="Registro Sanitário">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Registro Sanitário Nº Licença</label>
                            <input pInputText formControlName="nuRegistroSanitario" class="w-full" />
                        </div>
                        <div class="flex-1 min-w-[12rem]">
                            <label class="font-semibold block mb-2">Esfera</label>
                            <p-select appendTo="body" formControlName="inNatRegistroSanitario" [options]="opcoesNaturezaRegistroSanitario" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[10rem]">
                            <label class="font-semibold block mb-2">Indeterminado</label>
                            <p-select appendTo="body" formControlName="inValRegSanitario" [options]="opcoesPrazoIndeterminado" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        @if (exibirValidadeRegistroSanitario) {
                            <app-form-date-picker [control]="this.form.get('dtValRegistroSanitario')" [id]="'dtValRegistroSanitario'" [label]="'Validade'"></app-form-date-picker>
                        }
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-id-card" title="Alvará">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Alvará de Funcionamento - Nº</label>
                            <input pInputText formControlName="nuLicFuncionamento" class="w-full" />
                        </div>
                        <div class="flex-1 min-w-[10rem]">
                            <label class="font-semibold block mb-2">Indeterminado</label>
                            <p-select appendTo="body" formControlName="inValLicFuncionamento" [options]="opcoesPrazoIndeterminado" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        @if (exibirValidadeAlvara) {
                            <app-form-date-picker [control]="this.form.get('dtValLicFuncionamento')" [id]="'dtValLicFuncionamento'" [label]="'Validade'"></app-form-date-picker>
                        }
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-book" title="Registro">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Local de Registro</label>
                            <p-select appendTo="body" formControlName="inLocalRegistro" [options]="opcoesLocalRegistro" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-file-edit" title="Documento de Constituição">
                    <!-- Linha 1: Tipo de Documento + Nº do Documento de Constituição -->
                    <div class="flex flex-wrap gap-4 mb-3">
                        @if (!isJuntaComercial) {
                            <div class="flex-1 min-w-[14rem]">
                                <label class="font-semibold block mb-2">Tipo de Documento</label>
                                <p-select appendTo="body" formControlName="idDocumentoConstituicao" [options]="opcoesTipoDocumento" optionLabel="label" optionValue="value" styleClass="w-full" />
                            </div>
                        }
                        <div class="flex-1 min-w-[16rem]">
                            <label class="font-semibold block mb-2">{{ numeroDocumentoLabel }}</label>
                            <input pInputText formControlName="nuDocumentoConstituicao" class="w-full" />
                        </div>
                    </div>

                    <!-- Linha 2: Nº do Livro, Nº da Folha, Data do Documento, Dt. Última Atualização -->
                    <div class="flex flex-wrap gap-4 mb-3">
                        @if (!isJuntaComercial) {
                            <div class="flex-1 min-w-[8rem]">
                                <label class="font-semibold block mb-2">Nº do Livro</label>
                                <input pInputText formControlName="nuLivroDocConstituicao" class="w-full" />
                            </div>
                            <div class="flex-1 min-w-[8rem]">
                                <label class="font-semibold block mb-2">Nº da Folha</label>
                                <input pInputText formControlName="nuFolhaDocConstituicao" class="w-full" />
                            </div>
                        }
                        <app-form-date-picker [control]="this.form.get('dtDocumentoConstituicao')" [id]="'dtDocumentoConstituicao'" [label]="'Data do Documento'"></app-form-date-picker>
                        <app-form-date-picker [control]="this.form.get('dtAtualDocConstituicao')" [id]="'dtAtualDocConstituicao'" [label]="'Dt. Última Atualização'"></app-form-date-picker>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-sitemap" title="Serviço e Abrangência">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-[8rem]">
                            <label class="font-semibold block mb-2">Ensino</label>
                            <p-select appendTo="body" formControlName="inEnsino" [options]="opcoesEnsino" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[8rem]">
                            <label class="font-semibold block mb-2">Gestão</label>
                            <p-select appendTo="body" formControlName="inGestao" [options]="opcoesGestao" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[12rem]">
                            <label class="font-semibold block mb-2">Tipo de Gestão</label>
                            <p-select appendTo="body" formControlName="inGestaoTipo" [options]="opcoesTipoGestao" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Abrangência do Serviço</label>
                            <p-select appendTo="body" formControlName="inAbrangenciaServico" [options]="opcoesAbrangencia" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-briefcase" title="Funcionamento">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Condição de Funcionamento</label>
                            <p-select appendTo="body" formControlName="inCondicaoFuncionamento" [options]="opcoesCondicaoFuncionamento" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Regimento Interno</label>
                            <p-select appendTo="body" formControlName="inHomologacaoRi" [options]="opcoesRegimentoInterno" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <app-form-date-picker [control]="this.form.get('dtHomologacaoRi')" [id]="'dtHomologacaoRi'" [label]="'Dt. Homologação'"></app-form-date-picker>
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">Período de Mandato (CEM){{ exigePeriodoMandatoCem ? ' *' : '' }}</label>
                            <p-select appendTo="body" formControlName="idPeriodoMandato" [options]="opcoesPeriodoMandatoCem" optionLabel="label" optionValue="value" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-[14rem]">
                            <label class="font-semibold block mb-2">CNES - Número</label>
                            <input pInputText formControlName="nuCnes" class="w-full" />
                            @if (isSedeAdministrativa) {
                                <small class="block mt-1 text-surface-500"><i class="pi pi-info-circle"></i> CNES não se aplica a classificação Sede Administrativa.</small>
                            }
                        </div>
                    </div>
                </app-card-content>
            </div>
        </app-card-content>
    </form>
</div>
